<template>
  <div class="case">
    <h1 @click="toCaseMain">案例</h1>
    <div class="case_items clearfix">
      <div class="case-item" @click="toCase('first')">
        <img src="~static/img/index/home_case01.png" alt="" />
        <p>农业智慧</p>
      </div>
      <div class="case-item" @click="toCase('second')">
        <img src="~static/img/index/home_case02.png" alt="" />
        <p>恒美制衣</p>
      </div>
      <div class="case-item" @click="toCase('third')">
        <img src="~static/img/index/home_case03.png" alt="" />
        <p>古田旅游</p>
      </div>
      <div class="case-item" @click="toCase('fourth')">
        <img src="~static/img/index/home_case04.png" alt="" />
        <p>VR直播</p>
      </div>
      <div class="case-item" @click="toCase('fifth')">
        <img src="~static/img/index/home_case05.png" alt="" />
        <p>5G智造</p>
      </div>
      <div class="case-item" @click="toCase('sixth')">
        <img src="~static/img/index/home_case06.png" alt="" />
        <p>5G商场</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    toCase(type) {
      location.href=`case.html?type=${type}`
    },
    toCaseMain() {
      location.href="case.html"
    }
  }
}
</script>


<style lang="scss" scoped>
  .case {
    display: flex;
    flex-direction: column;
    align-items: center;
    background-color: #F5F7F9;
    padding-top: 100px;
    padding-bottom: 68px;
    margin-bottom: 100px;
    h1 {
      color: #2C3B5C;
      font-size: 36px;
      line-height: 36px;
      margin-bottom: 60px;
      text-align: center;
      cursor: pointer;
      /* font-family:PingFangSC-Semibold; */
    }
    .case_items {
      display: flex;
      flex-wrap: wrap;
      max-width: 1044px;
      justify-content: center;
      .case-item {
        float: left;
        height: 238px;
        width: 304px;
        padding: 0 22px;
        position: relative;
        margin-bottom: 22px;
        cursor: pointer;
        img {
          width: 100%;
          height: 200px;
          border-radius: 6px;
        }
        p {
          position: absolute;
          bottom: 10px;
          left: 46px;
          width: 256px;
          line-height: 56px;
          text-align: center;
          color: #2C3B5C;
          font-size: 18px;
          font-weight: bold;
          border-radius: 6px;
          background-color: #fff;
          box-shadow:0px 10px 10px 0px rgba(123,123,123,0.1);
        }
      }
    }
  }
</style>




// WEBPACK FOOTER //
// src/components/index/case.vue